/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { RegularButton } from 'pg-ui-library';
import { useNavigate } from 'react-router-dom';
import launchLogo from 'src/assets/launch_logo_tp.png';
import { Container, ContentBox, IconWrapper, Title, Message, Spinner, RedirectInfo } from './styles';

const VmsRedirect: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  // --- waiting for the new tab
  // useEffect(() => {
  //   // Open blank tab immediately (before timer starts)
  //   const newTab = window.open('', '_blank');

  //   const timer = setInterval(() => {
  //     setCountdown(prev => {
  //       if (prev <= 1) {
  //         clearInterval(timer);

  //         if (newTab) {
  //           newTab.location.href = 'https://www.launchvms.net/login';
  //         }

  //         return 0;
  //       }
  //       return prev - 1;
  //     });
  //   }, 1000);

  //   return () => clearInterval(timer);
  // }, []);

  const handleRedirect = () => {
    window.open('https://www.launchvms.net/login', '_blank', 'noopener,noreferrer');
  };

  return (
    <Container>
      <ContentBox>
        <IconWrapper>
          <img src={launchLogo} alt="Launch VMS Logo" />
        </IconWrapper>
        <Title>Redirecting to VMS</Title>
        {/* <Message>
          You will be automatically redirected to VMS in <strong>{countdown}</strong> second
          {countdown !== 1 ? 's' : ''}.
        </Message> */}

        <Message>
          The VMS integration is currently under development.
          <br />
          Please click the button below to access Launch VMS in a new tab.
        </Message>

        <RegularButton onClick={handleRedirect}>Go to Launch VMS</RegularButton>
        {/* <Spinner /> */}
        {/* <RedirectInfo>
          If the redirect does not occur automatically,{' '}
          <a href="https://www.launchvms.net/login" target="_blank" rel="noopener noreferrer">
            click here
          </a>
          .
        </RedirectInfo> */}
      </ContentBox>
    </Container>
  );
};

export default VmsRedirect;
